import { ITextEnhancements } from "store/entities/enhancements/interfaces";

import { BaseApi } from "../base";

export class TextEnhancementsApi extends BaseApi {
  protected readonly prefix = "textEnhancements";
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  fetchEnhancement = (payload: ITextEnhancements) => this.post("", payload);
}
